<template>
  <div class="certiciateorder">

    <div class="status info">
      <span class="h3">You may be eligible</span>
      <p>To have the fee for your certificate waived. We will review your application and will notify you by emailonce a
        decision has been made.</p>
      <p>Supported file types: PDF, JPEG, TIFF, PNG. The maximum file size is 20 MB. Do not use special characters (such
        as apostrophes) and accents in file names.</p>
    </div>
    <h1 id="formTitle">Fee Waiver Application</h1>

    <form @submit="submitForm" id="submitForm">
      <ol class="questions">
        <li>
          <fieldset>
            <legend>
              <span class="h3 label">Step 1: Evidence of financial hardship</span>
            </legend>
            <ul class="questions">
              <li>
                <label for="evidenceReason"> <span class="label">Tell us how you are suffering financial hardship</span>
                  <abbr class="required" title="(required)">*</abbr></label>
                <input id="evidenceReason" v-model="form.evidenceReason" name="attributes.evidenceReason" type="text"
                  required="required" class="stretchWidth" maxlength="1024">
              </li>
              <li>
                <legend>
                  <span class="h4 label">Attach your supporting evidence</span>
                  <abbr class="required" title="(required)">*</abbr>
                </legend>
                <input id="evidenceFile" @change="handleUpload" type="file" name="evidenceFile" required="true"
                  :accept="uploads.acceptedTypes">
              </li>
              <li>
                <div class="status info">
                  <p>
                    You must provide evidence of financial hardship. The following examples would be accepted:
                  </p>
                  <ol class="disc-list">
                    <li>Concession or health care card</li>
                    <li>Bank statements</li>
                    <li>Evidence of employment or Centrelink status</li>
                    <li>Evidence of inability to access fee payable, such as a leter from
                      <ol class="disc-list inner-list">
                        <li>Domestic voilience support service, your doctor, councellor or social worker verifying that a
                          domestic voilience situation prevents you being able to pay the fee</li>
                        <li>Crisis or temporary accommodation service verifying that you are vulnerable and currently
                          using their services</li>
                      </ol>
                    </li>
                  </ol>
                  <br />
                  <p>One of these documents alone may not be enough evidence and your fee waived application may be
                    rejected if the evidence is not enough</p>
                </div>
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <legend>
              <span class="h3 label">Step 2: Evidence of immediate need</span>
            </legend>
            <ul class="questions">
              <li>
                <label for="immediateReason"> <span class="label">Why do you need the certificate immediately?</span>
                  <abbr class="required" title="(required)">*</abbr></label>
                <input id="immediateReason" v-model="form.immediateReason" name="attributes.immediateReason" type="text"
                  required="required" class="stretchWidth" maxlength="1024">
              </li>
              <li>
                <legend>
                  <span class="h4 label">Attach your supporting evidence</span>
                  <abbr class="required" title="(required)">*</abbr>
                </legend>
                <input id="immediateFile" @change="handleUpload" type="file" name="immediateFile" required="true"
                  :accept="uploads.acceptedTypes">
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <ul class="questions compact">
              <li class="applicantPreferredContactEmail">
                <label for="applicantPreferredContactEmail"> <span class="label">Email</span> <abbr class="required"
                    title="(required)">*</abbr></label>
                <input id="applicantPreferredContactEmail" v-model="form.applicantPreferredContactEmail"
                  name="attributes.applicantPreferredContactEmail" type="email" required="required" class="stretchWidth"
                  maxlength="255">
              </li>
              <li class="applicantPreferredContactMobile">
                <label for="applicantPreferredContactMobile">
                  <span class="label">Contact number</span>
                  <abbr class="required" title="(required)">*</abbr>
                  <small class="hint">Mobile preferred</small>
                </label>
                <input id="applicantPreferredContactMobile" v-model="form.applicantPreferredContactMobile"
                  name="attributes.applicantPreferredContactMobile" type="tel" pattern=".{10,}" required="required"
                  class="stretchWidth" maxlength="15">
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <legend>
              <span class="label">What type of certificate do you want to order?</span>
              <abbr class="required" title="(required)">*</abbr>
            </legend>
            <ul class="choices">
              <li>
                <input id="birthCertificate" v-model="form.certificateOrderProduct" value="birthCertificate"
                  name="attributes.product" type="radio" required="">
                <label for="birthCertificate">Birth certificate</label>
              </li>
              <li>
                <input id="deathCertificate" v-model="form.certificateOrderProduct" value="deathCertificate"
                  name="attributes.product" type="radio" required="">
                <label for="deathCertificate">Death certificate</label>
              </li>
              <li>
                <input id="marriageCertificate" v-model="form.certificateOrderProduct" value="marriageCertificate"
                  name="attributes.product" type="radio" required="">
                <label for="marriageCertificate">Marriage certificate</label>
              </li>
              <li>
                <input id="changeOfNameCertificate" v-model="form.certificateOrderProduct" value="changeOfNameCertificate"
                  name="attributes.product" type="radio" required="">
                <label for="changeOfNameCertificate">Change of name certificate</label>
              </li>
              <li>
                <input id="other" v-model="form.certificateOrderProduct" value="other" name="attributes.product"
                  type="radio" required="">
                <label for="other">Other</label>
              </li>
            </ul>
          </fieldset>
        </li>
        <li v-if="form.certificateOrderProduct == 'other'">
          <label for="productOther"> <span class="label">Tell us what you want to order</span> <abbr class="required"
              title="(required)">*</abbr></label>
          <input id="productOther" v-model="form.productOther" name="attributes.productOther" type="text"
            required="required" class="stretchWidth" maxlength="255">
        </li>
        <li>
          <fieldset>
            <legend>
              <span class="h3">Upload your documentation</span>
              <div class="status info">
                <p>Supported file types: PDF, JPEG, PNG. </p>
                <p>The maximum file size is 20 MB. </p>
                <p>Do not use special characters (such as apostrophes) and accents in file names.</p>
              </div>
            </legend>

            <ul class="questions">
              <li>
                <legend>
                  <span class="h4 label">Attach supporting documents</span>
                  <small class="hint">Upload up to 6 supporting document files (e.g. proof of ID documents).</small>
                </legend>
                <fieldset>
                  <table id="supportingDocumentationFiles" class="stretchWidth">
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="index in uploads.supportingFiles" :key="index"
                        :id="'supportingDocumentationRow' + index">
                        <td>
                          <input :id="'supportingDocumentation' + index" ref="'supportingDocumentation'+index"
                            @change="handleUpload" type="file" :name="'supportingDocumentation' + index"
                            :accept="uploads.acceptedTypes">
                        </td>
                        <td class="fileProgress">
                        </td>
                        <td v-if="uploadExists('supportingDocumentation' + index)" class="fileOptions">
                          <div class="removeUpload" @click="removeUpload"
                            :targetUpload="'supportingDocumentation' + index">
                            x</div>
                        </td>
                        <td v-else>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </fieldset>
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <ul class="questions">
              <li>
                <label for="description">
                  <span class="label">Any comments to be considered as part of this application</span>
                </label>
                <textarea id="applicantComment" class="stretchWidth" rows="5" v-model="form.applicantComment"
                  name="attributes.applicantComment"></textarea>
              </li>
            </ul>
          </fieldset>
        </li>
        <li id="uploading">
          <p v-if="uploads.uploading > 0">Uploading your attachment... ({{ uploads.uploading }} remaining)</p>
          <p v-else></p>
        </li>
        <li id="inProgress">
          <p v-if="inProgress">Submitting your enquiry...</p>
          <p v-else> </p>
        </li>
        <li>
          <fieldset>
            <ul class="actions">
              <li>
                <strong><button :disabled="uploads.uploading > 0 || inProgress" id="submitButton">Submit
                    application</button></strong>
              </li>
            </ul>
          </fieldset>
        </li>
      </ol>
    </form>
    <hr />
  </div>
</template>

<script>
import sppapi from '../../sppapi.js';

export default {
  name: 'TheFeeWaiverForm',
  data: function () {
    return {
      processId: 'orderFeeWaiver',
      form: {
        applicantName: '',
        applicantPreferredContactMobile: '',
        applicantPreferredContactEmail: '',
        applicantComment: '',
        productOther: '',
        certificateOrderProduct: ''
      },
      contactPhone: '',
      contactEmail: '',
      uploads: {
        uploadIds: [],
        uploading: 0,
        acceptedTypes: '.jpg, .tiff, .png, .jpeg, .pdf',
        supportingFiles: 1
      },
      inProgress: false,
    }
  },
  computed: {

  },
  methods: {
    removeUpload: function (event) {
      event.preventDefault()
      let targetUploadId = event.target.attributes['targetUpload'].value
      document.getElementById(targetUploadId).value = ''
      this.uploads.uploadIds = this.uploads.uploadIds.filter(uploadId => uploadId.fieldId !== targetUploadId)
      return false
    },
    uploadExists: function (fieldId) {
      return this.uploads.uploadIds.filter(uploadId => uploadId.fieldId == fieldId).length
    },
    handleUpload: function (event) {
      const selection = event.target.files[0]
      const ext = selection.name.split('.').pop();
      if (this.uploads.acceptedTypes.indexOf(ext) < 0) {
        document.getElementById(event.target.id).value = ''
        return
      }

      this.uploads.uploading++
      const reader = new FileReader()
      reader.onload = (e) => {
        sppapi.uploadFile(this, selection.name, event.srcElement.name, e.target.result)
      }
      reader.readAsDataURL(selection)
    },
    submitForm: function (event) {
      event.preventDefault();
      this.contactPhone = this.form.applicantPreferredContactMobile;
      this.contactEmail = this.form.applicantPreferredContactEmail;

      sppapi.startProcessAndCompleteTask(this);
    }
  },
  components: {
  }
}

</script>

<style scoped lang="scss">
#inProgress {
  height: 1em;
}

#uploading {
  height: 1em;
}

.applicantPreferredContactEmail {
  width: 100%;
}

#supportingDocumentationFiles td {
  padding: 0 0 1.2em 0;
  background: white;
}

#supportingDocumentationFiles th {
  display: none;
}

.removeUpload {
  cursor: pointer;
}
</style>
